import Contact from "../components/Contact.js";
import Footer from "../components/Footer.js";
import { Box } from "@mui/material";

export default function ContactPage() {
  return (
    <>
      {/* Top padding to clear the fixed Navbar */}
      <Box sx={{ pt: "72px" }}>
        <Contact />
      </Box>
      <Footer />
    </>
  );
}